import { LandingFooter } from '@/features/landing/components/LandingFooter';
import { LandingHeader } from '@/features/landing/components/LandingHeader';
import { SecaoAnaliseComparativa } from '@/features/landing/components/SecaoAnaliseComparativa';
import { SecaoAssessoria } from '@/features/landing/components/SecaoAssessoria';
import { SecaoClube } from '@/features/landing/components/SecaoClube';
import { SecaoComoFunciona } from '@/features/landing/components/SecaoComoFunciona';
import { SecaoCta } from '@/features/landing/components/SecaoCta';
import { SecaoHero } from '@/features/landing/components/SecaoHero';
import { SecaoRecursos } from '@/features/landing/components/SecaoRecursos';

/**
 * Página pública em `/` (F1 — porta de entrada do domínio).
 *
 * Antes desta tela, `/` redirecionava para o dashboard, que redirecionava para
 * o login: quem não tinha conta batia num formulário sem nunca ler o que o
 * produto faz. Agora a raiz é a landing, e o login continua em `/login`.
 *
 * Fica FORA do `AppLayout` — não tem sidebar nem header do app, e não exige
 * sessão. A única coisa que ela lê da sessão é o estado do CTA.
 */
export function LandingPage() {
  return (
    <div className="min-h-screen bg-background">
      <LandingHeader />
      <main>
        <SecaoHero />
        <SecaoRecursos />
        <SecaoAnaliseComparativa />
        <SecaoComoFunciona />
        <SecaoAssessoria />
        <SecaoClube />
        <SecaoCta />
      </main>
      <LandingFooter />
    </div>
  );
}
